import { render, staticRenderFns } from "./UnauthorisedPopUp.vue?vue&type=template&id=a8654f90&scoped=true"
import script from "./UnauthorisedPopUp.vue?vue&type=script&lang=js"
export * from "./UnauthorisedPopUp.vue?vue&type=script&lang=js"
import style0 from "./UnauthorisedPopUp.vue?vue&type=style&index=0&id=a8654f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8654f90",
  null
  
)

export default component.exports